import React, {useCallback, useEffect, useMemo, useState} from "react";
import {addNewUser, getRoles} from "../../../../service/adminService";
import {Button, ButtonToolbar, Form, Modal, SelectPicker} from "rsuite";
import {userModel} from "../../../form/models";
import {getClearances} from "../../../../service/dataService";

const defaultState = {
  sellStatement: '',
  clearance: 'None',
  role: 'USER',
};

const AddUserModal = (props) => {
    const { open, handleClose } = props

    const [localState, setLocalState] = useState(defaultState);
    const [roles, setRoles] = useState([]);
    const [clearances, setClearances] = useState([]);

    useEffect(() => {
        getRoles().then((roles) => {
            setRoles(roles.map(ele => ({label: ele.roleName, value: ele.roleName})));
        });
        getClearances().then((data) => {
            // format the data into InputPicker format for now
            setClearances(data.map(ele => ({label: ele.clearanceName, value: ele.clearanceName})));
        });
    }, []);

    const submitUserAdd = useCallback((isFormValid) => {
        if(!isFormValid) return;
        addNewUser(localState).then((response) => {
            handleClose(response);
            setLocalState(defaultState);
        });
    }, [handleClose, localState]);

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = useCallback((event) => {
        setLocalState({...localState, ...event});
    }, [localState]);

    return useMemo(() => {
        return (
        <Modal
            open={open}
            onClose={handleClose}
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title>Add User</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            </Modal.Body>
            <Form
                layout="horizontal"
                model={userModel}
                onChange={handleFormChange}
                onSubmit={submitUserAdd}
                formValue={localState}
            >
                <Form.Group>
                    <Form.ControlLabel>Email</Form.ControlLabel>
                    <Form.Control name="email"/>
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>First Name</Form.ControlLabel>
                    <Form.Control name="firstName"/>
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Last Name</Form.ControlLabel>
                    <Form.Control name="lastName"/>
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Role</Form.ControlLabel>
                    <Form.Control name="role"
                                  accepter={SelectPicker}
                                  data={roles}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Clearance</Form.ControlLabel>
                    <Form.Control name="clearance"
                                  accepter={SelectPicker}
                                  data={clearances}
                    />
                </Form.Group>
                <Form.Group>
                    <ButtonToolbar>
                        <Button type="submit" appearance="primary">
                            Ok
                        </Button>
                        <Button onClick={handleClose} appearance="default">
                            Cancel
                        </Button>
                    </ButtonToolbar>
                </Form.Group>
            </Form>
        </Modal>
        );
    }, [clearances, handleClose, handleFormChange, localState, open, roles, submitUserAdd]);
};

export default AddUserModal;